import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type AddUserResponseType = {};

export type UserParams = {
  email: string;
  name: string;
  phone_number: string;
  role_id: number;
  store_ids: (number | undefined)[] | undefined;
  franchise_owner_id?: number;
  is_active?: boolean;
};

export const useAddUser = (
  options?: MutationOptions<
    AddUserResponseType,
    UserParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (userData) => {
      const { data } = await api.post<ApiResponse<AddUserResponseType>>(
        '/user',
        userData
      );

      return data.data;
    },
    ...options,
  });
